<template>
  <div>
    <tk-flex between >
      <public-header title="订单详情" show-back></public-header>
      <a-button v-if="pageData && pageData.objectId && pageData.status === '2' && pageData.feedbackRecord && pageData.feedbackRecord.length && can('replyOrderModel')" type="primary" @click="areaModal = true" >
        回复
      </a-button>
    </tk-flex>
    <a-spin :spinning="loading">
      <div class="full-width bg-white border-radius-12 p-24" style="color: #363B45" >
        <tk-flex middle wrap :gutter="8"  >
          <div class="p-r-8 font-bold font-20">订单号：{{ pageData.number }}</div>
          <div class="p-x-8 p-y-4" :style="{'border-radius': '6px','border': '1px solid' + statusColor(pageData),'color': statusColor(pageData)}" >{{ pageData | statusView }}</div>
          <div class="p-x-8 p-y-4" v-if="(pageData.status === '1' || pageData.status === '2' || pageData.status === '3') && pageData.refundStatus" :style="{'border-radius': '6px','border': '1px solid' + refundStatusColor(pageData),'color': refundStatusColor(pageData)}" >{{ pageData | refundStatusView }}</div>
          <div class="p-x-8 p-y-4" style="border-radius: 6px;border: 1px solid #FF2A58;color: #FF2A58;" >{{ pageData.serveType === '0' ? '到店安装' : '上门安装' }}</div>
        </tk-flex>
        <!-- 基本信息 -->
        <div>
          <div class="font-14 font-bold m-t-24 m-b-20" >基本信息</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" v-if="pageData && pageData.objectId" >
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              战区：{{ pageData.level === '4' ? pageData.agent.department.parentNode.name : pageData.department.parentNode.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              大区：{{ pageData.level === '4' ? pageData.agent.department.name : pageData.department.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              所属地区：{{ pageData.level === '4' ? $tkRegions.getFullName(pageData.agent.region) : $tkRegions.getFullName(pageData.region) }}
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              门店：{{ pageData.store.fullName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              下单用户：{{ pageData.user.nickName }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              手机号：{{ pageData.user.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              购买方式：{{ pageData.buyMethod === '0' ? '以旧换新' : '直接购买' }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              服务类型：{{ pageData.serveType === '0' ? '到店安装' : '上门安装' }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              创建时间：{{ pageData.createdAt | date }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.refundStatus === '3'"  >
              退款时间：{{ pageData.refundTime | date }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!-- 上门服务地址 -->
        <div v-if="pageData.serveType === '1'">
          <div class="font-14 font-bold m-t-24 m-b-20" >上门服务地址</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              联系人：{{ pageData.shippingAddressData.name }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              联系电话：{{ pageData.shippingAddressData.phone }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" style="word-break: break-all;" >
              地址：{{ pageData.shippingAddressData.regionCoder + pageData.shippingAddressData.address }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!-- 退款失败 -->
        <div v-if="pageData.refundStatus === '2'">
          <div class="font-14 font-bold m-t-24 m-b-20" >退款失败</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              拒绝原因：{{ pageData.rejectReason }}
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
              拒绝时间：{{ pageData.rejectTime | date }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!-- 订单反馈 -->
        <div v-if="pageData && pageData.feedbackRecord && pageData.feedbackRecord.length">
          <div class="font-14 font-bold m-t-24 m-b-20" >订单反馈</div>
          <a-row :gutter="[12,12]" class="font-12" style="color: #363B45" >
            <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(t,i) in pageData.feedbackRecord" :key="i" style="word-break: break-all;"  >
              {{ t.type === 'user' ? '用户' : '平台' }}反馈内容：{{ t.content }}
            </a-col>
          </a-row>
          <div class="m-t-20" style="height: 1px;background-color: #E1E4EB;" ></div>
        </div>
        <!-- 订单详情 -->
        <div style="width: 100%;overflow: hidden;">
          <div class="font-14 font-bold m-t-24 m-b-20" >订单详情</div>
          <a-table
            v-if="device !== 'mobile'"
            style="width: 100%"
            :columns="columns"
            :data-source="data"
            :pagination="false"
            :scroll="{x: 600}"
            size="small"
          >
            <div slot="image" slot-scope="text">
              <viewer v-if="text" :images="text">
                <img v-for="(t,i) in text" :key="i" :src="t" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
              </viewer>
              <span v-else> 暂无 </span>
            </div>
            <template slot="footer"  >
              <div :style="{textAlign: device === 'mobile' ? 'left' : 'right'}">
                共计{{ pageData.gift ? '2' : '1' }}个商品，
                商品金额：￥{{ pageData.priceAll || 0 }}，
                <span v-if="pageData.hasCoupon" >优惠券抵扣：-￥{{ pageData.couponPrice || 0 }}，</span>
                <span v-if="pageData.serveType !== '0'" >上门服务费：￥{{ pageData.visitCost || 0 }}，</span>
                总计金额：￥{{ pageData.orderAmount }}
              </div>
            </template>
          </a-table>
          <div v-else>
            <a-descriptions bordered v-for="(item,index) in data" :key="index" style="margin-bottom: 20px">
              <a-descriptions-item
                v-for="( itm, i) in columns" :key="`item${i}`"
                :label="itm.title"
              >
                <div v-if="itm.dataIndex === 'image'">
                  <viewer v-if="item[itm.dataIndex]" :images="item[itm.dataIndex]">
                    <img v-for="(t,i) in item[itm.dataIndex]" :key="i" :src="t" style="width: 40px;height:40px;object-fit:cover;border-radius: 6px;border: 1px solid #DBDDE1;" :style="{'display': i===0?'':'none'}" />
                  </viewer>
                  <span v-else> 暂无 </span>
                </div>
                <div v-else>
                  {{item[itm.dataIndex]}}
                </div>
              </a-descriptions-item>
            </a-descriptions>
            <div :style="{textAlign: device === 'mobile' ? 'left' : 'right'}">
              共计{{ pageData.gift ? '2' : '1' }}个商品，
              商品金额：￥{{ pageData.priceAll || 0 }}，
              <span v-if="pageData.hasCoupon" >优惠券抵扣：-￥{{ pageData.couponPrice || 0 }}，</span>
              <span v-if="pageData.serveType !== '0'" >上门服务费：￥{{ pageData.visitCost || 0 }}，</span>
              总计金额：￥{{ pageData.orderAmount }}
            </div>
          </div>
        </div>
      </div>
    </a-spin>

    <!-- 回复弹框 -->
    <!-- 弹框 -->
    <a-modal
      :title="'回复'"
      :confirmLoading="confirmLoading"
      :visible="areaModal"
      @ok="save"
      @cancel="
        () => {
          areaModal = !areaModal;
          area = {};
        }
      "
    >
      <ak-type-input ref="feedback" v-model="feedback" :field="feedbackField" hideLabel style="width: 100%" />
    </a-modal>
  </div>
</template>
<script>
import publicHeader from '../../components/publicHeader.vue'
import { statusColor, refundStatusColor } from '../../assets/js/utils.js'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      columns: [
        {
          title: '图片',
          dataIndex: 'image',
          key: 'image',
          scopedSlots: { customRender: 'image' },
          width: 100
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
          scopedSlots: { customRender: 'type' },
          width: 100
        },
        {
          title: '商品编号',
          dataIndex: 'serial',
          key: 'serial',
          width: 150
        },
        {
          title: '系列',
          dataIndex: 'series',
          key: 'series',
          width: 100
        },
        {
          title: '商品名称',
          dataIndex: 'name',
          key: 'name',
          width: 150
        },
        {
          title: '电压',
          dataIndex: 'voltage',
          key: 'voltage',
          width: 80
        },
        {
          title: '容量',
          dataIndex: 'capacity',
          key: 'capacity',
          width: 100
        },
        {
          title: '数量',
          dataIndex: 'number',
          key: 'number',
          width: 80
        },
        {
          title: '价格(元)',
          key: 'price',
          dataIndex: 'price',
          width: 100
        }
      ],
      data: [
        {
          image: '',
          type: '电池商品',
          serial: '',
          series: '',
          name: '',
          voltage: '',
          capacity: '',
          number: '1',
          price: ''
        }
      ],
      confirmLoading: false,
      areaModal: false, // 弹框
      feedback: '', // 战区
      feedbackField: {
        name: 'feedback',
        type: 'String',
        placeholder: '请输入回复',
        validators: [
          (val) => val ? null : '不可为空'
        ]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    statusColor,
    refundStatusColor,
    // 初始化菜单按钮
    async init () {
      try {
        const { data } = await this.$tkParse.get(`/classes/order/${this.$route.query.id}`, {
          params: { include: 'store,user,commodity,commodity.voltage,commodity.capacity,gift,series,shippingAddress' }
        })
        console.log(data)
        this.data[0].image = data.commodityData.images
        this.data[0].serial = data.commodityData.number
        this.data[0].series = data.series.name
        this.data[0].name = data.commodityData.name
        this.data[0].voltage = data.commodityData.voltage ? data.commodityData.voltage.name : '-'
        this.data[0].capacity = data.commodityData.capacity ? data.commodityData.capacity.name : '-'
        this.data[0].price = data.price
        // 如果data的长度大于1
        if (this.data.length > 1) {
          this.data.splice(1, 1)
        }
        if (data.gift) {
          this.data.push({
            image: [data.gift.image],
            type: '赠送商品',
            serial: '-',
            series: '-',
            name: data.gift.name,
            voltage: '-',
            capacity: '-',
            number: '1',
            price: data.gift.price
          })
        }

        this.pageData = data
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    // 保存
    async save () {
      try {
        if (this.feedback === '') {
          this.$notification['warning']({
            message: '警告',
            description: '内容不可为空'
          })
          return
        }
        this.confirmLoading = true
        await this.$tkParse.post(`/order/feedback`, {
          order: this.pageData.objectId,
          user: this.$store.state.user.objectId,
          feedback: this.feedback
        })
        this.$notification['success']({
          message: '设置成功',
          description: '保存成功'
        })
        this.feedback = ''
        this.areaModal = false
        this.confirmLoading = false
        this.init()
      } catch (error) {
        console.log(error)
        this.confirmLoading = false
        this.$notification['error']({
          message: '设置失败',
          description: '网络错误,请重试'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
